module.exports = __webpack_public_path__ + "img/taken_printing.243dc7ea.svg";